import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { trigger, transition, query, style, animate, group } from '@angular/animations';
import { AppService } from 'projects/admin/src/app/core/services/app.service';
import { ActionEvent } from '@shared/models/common.model';

const left = [
  query(':enter, :leave', style({ position: 'fixed', width: '100%' }), { optional: true }),
  group([
    query(':enter', [style({ transform: 'translateX(-100%)' }), animate('.5s ease-out', style({ transform: 'translateX(0%)' }))], {
      optional: true,
    }),
    query(':leave', [style({ transform: 'translateX(0%)' }), animate('.5s ease-out', style({ transform: 'translateX(100%)' }))], {
      optional: true,
    }),
  ]),
];

const right = [
  query(':enter, :leave', style({ position: 'fixed', width: '100%' }), { optional: true }),
  group([
    query(':enter', [style({ transform: 'translateX(100%)' }), animate('.5s ease-out', style({ transform: 'translateX(0%)' }))], {
      optional: true,
    }),
    query(':leave', [style({ transform: 'translateX(0%)' }), animate('.5s ease-out', style({ transform: 'translateX(-100%)' }))], {
      optional: true,
    }),
  ]),
];

@Component({
  selector: 'app-new-project',
  templateUrl: './new-project.component.html',
  styleUrls: ['./new-project.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('animSlider', [
      transition(':increment', right),
      transition(':decrement', left),
    ]),
  ],  
})

export class NewProjectComponent implements OnInit {
  slide = 0;
  projectId = null;
 
  constructor(
    private fb: FormBuilder,
    private appservice: AppService

  ) { }

  ngOnInit(): void {
    this.projectId = null;
  }

  onAction(event:ActionEvent){
    if (event.type=='create'){
      if (event.payload.exercise){
        this.slide = 1;
        this.projectId = event.payload.id;
      } else{
        this.slide = 2;
      }

      
    }
  }

  onClose(successful=false){
    this.appservice.endCreateProject(successful ? this.projectId: null)
  }

}
